import { render, staticRenderFns } from "./GlobalRoundModal.vue?vue&type=template&id=6cb3482a&"
import script from "./GlobalRoundModal.vue?vue&type=script&lang=js&"
export * from "./GlobalRoundModal.vue?vue&type=script&lang=js&"
import style0 from "./GlobalRoundModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports